module.exports = __webpack_public_path__ + "img/pic_9.33591652.jpg";